import { useNavigate as useBaseNavigate, useLocation } from "react-router-dom";

export const useNavigate = () => {
  const baseNavigate = useBaseNavigate();
  const location = useLocation();

  const navigate = (path: string) => {
    baseNavigate(path);
  };

  return { navigate, location };
};
